module.exports = __webpack_public_path__ + "img/pic.008bb6f4.png";